<template>
  <div>
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="drugDataLoading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!drugDataLoading">
          <div class="row">
            <div class="col-md-4">
              <DrugGeneralInfo
                ref="generalInfo"
                v-if="drug"
                :smallValidDates="true"
                :drug="drug"
                :combineInvoices="combineInvoices?.[drug.id]"
                :invoices="invoices"
                :allStoreDrugsData="allStoreDrugsData"
                :profitCalculation="profitCalculation"
                :ordersStat="ordersStat"
                :storeDrugData="storeDrugData"
                :soldData="soldData"
                :freezeInvoices="freezeInvoices[drug.id]"
                :inModal="true"
              />
            </div>
            <div class="col col-md-4">
              <DrugSoldStatistics
                :drug="drug"
                :invoices="invoices"
                :ordersStat="ordersStat"
                :soldData="soldData"
                :inModal="true"
              />
            </div>
            <div class="col col-md-4">
              <SmallPriceBlock
                :drug="drug"
                :invoices="invoices"
                :profitCalculation="profitCalculation"
              />

              <div class="form-group text-left">
                <label class="text-muted" for="">Наименование на английском</label>
                <input type="text"
                       placeholder="Наименование на английском"
                       v-model="drug.en_title"
                       class="form-control">
              </div>

              <div class="mb-3 text-left card p-2">
                <label class="text-muted">Название препарата для страны/поставщика</label>
                <TitleForSuppliers
                  ref="suppliersTitles"
                  :records="drug.details"
                />
              </div>

              <SalesPricesInfo v-if="drug.infoPrices && drug.infoPrices.lenght" :drug="drug"/>

              <div class="mt-2 text-left">
                <div class="form-group">
                  <p>Комментарий к закупке</p>
                  <textarea type="text" v-model="drug.purchase_comment" class="form-control" rows="2"/>
                </div>
                <div class="form-group">
                  <p>Коэфициент закупки у поставщиков</p>
                  <input placeholder="Коэфициент 2,5,10...." type="text"
                         :class="{'form-control': true, 'bg_success': drugDetails.suppliers_data.order_rate.value && drugDetails.suppliers_data.order_rate.value !== 0}"
                         v-model="drugDetails.suppliers_data.order_rate.value">
                </div>
                <div class="form-group">
                  <p>Фасовка закупки блистеров</p>
                  <input placeholder="Коэфициент 2,5,10...." type="text"
                         :class="{'form-control': true, 'bg_success': drugDetails.suppliers_data.oposit_order_rate.value && drugDetails.suppliers_data.oposit_order_rate.value !== 0}"
                         v-model="drugDetails.suppliers_data.oposit_order_rate.value">
                </div>
              </div>

            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="card" v-if="!drugDataLoading && drug">
      <div class="card-body">
        <template v-if="drug.combined_type === 1">
          <div class="input-group w-25 mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon2"><strong>Заказ на количество:</strong></span>
            </div>
            <input type="number" v-model="drugRequestQty" class="form-control">
          </div>
          <div v-for="cd in drug.combined_drugs">
            <h4 class="text-left">Заказ компонента: <strong>{{ cd.drug.title }}</strong> ({{ cd.drug.id }} x {{
                cd.rate
              }})</h4>
            <DrugOrderBlock
              :ref="`combined_order_${cd.drug.id}`"
              :requiredQty='Math.floor(drugRequestQty ?? 0) * cd.rate'
              :drug="cd.drug"
            />
          </div>
        </template>
        <template v-else>
          <CreatedDrugOrder
            v-if="showOrderComponent"
            ref="drugOrder"
            :countrySelected="countrySelected"
            :updateOrderDrug="(invoices, drug = null) => updateOrderedInvoices(drug.id, invoices, drug)"
            :requiredQty='getRequiredQty()'
            :drug="drug"
            :drugDetails="drugDetails"
            :costPrice="invoices && Math.round((invoices[0] && invoices[0].cost_price || 0) * 100) / 100"
            :closeModal="closeModal"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import CreatedDrugOrder from "@/views/nomenclature/components/details/CreatedDrugOrder.vue";
import DrugGeneralInfo from "@/views/nomenclature/components/details/DrugGeneralInfo.vue";
import DrugSoldStatistics from "@/views/nomenclature/components/details/DrugSoldStatistics.vue";
import SmallPriceBlock from "@/views/nomenclature/components/details/SmallPriceBlock.vue";
import DrugOrderBlock from "@/views/nomenclature/components/drugOrder/DrugOrderBlock.vue";
import TitleForSuppliers from "@/views/nomenclature/components/details/TitleForSuppliers.vue";

export default {
  props: ['drugId', 'countrySelected', 'profitCalculation', 'closeModal', 'updateOrderedInvoices'],
  components: {
    TitleForSuppliers,
    DrugOrderBlock,
    CreatedDrugOrder,
    DrugGeneralInfo,
    DrugSoldStatistics,
    SmallPriceBlock,
  },
  data() {
    return {
      isSavingOrder: false,
      drugDataLoading: false,
      showOrderComponent: false,
      drugRequestQty: 0,
      drug: null,
      invoices: [],
      allStoreDrugsData: {},
      storeDrugData: {},
      combineInvoices: {},
      soldData: {},
      freezeInvoices: {},
      ordersStat: {},
      drugDetails: {},
    }
  },
  created() {
    this.getDrugData();
  },
  methods: {
    getRequiredQty() {
      const qty = this.$refs.generalInfo?.requiredQty ?? 0;
      return qty < 0 ? (qty * -1) : 0;
    },
    async createOrder() {
      if (!this.drug?.id) return;
      if (!this.drug.combined_type) {
        await this.$refs.drugOrder.createOrder();
      } else {
        if (this.isSavingOrder) return;
        this.isSavingOrder = true;
        for (let i = 0; i < this.drug.combined_drugs.length; i++) {
          await this.$refs[`combined_order_${this.drug.combined_drugs[i].drug.id}`][0].createOrder();
        }
        if (this.closeModal) {
          this.closeModal();
        }
      }
    },
    async getDrugData() {
      this.drugDataLoading = true;
      let {data: r_data} = await api.post('/nomenclature/synchronize', {
        filter: {
          searchOptions: {},
          searchData: this.drugId,
          type: 2
        }
      })
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.invoices = r_data.invoices[this.drugId] || [];
        this.allStoreDrugsData = r_data.storeDrugData ?? {};
        this.storeDrugData = r_data.storeDrugData[this.drugId] ?? {};
        this.soldData = r_data.soldData[this.drugId] || {};
        this.ordersStat = r_data.ordersStat[this.drugId] || {};
        this.freezeInvoices = r_data.freezeInvoices || null;
        this.combineInvoices = r_data.combineInvoices;
        const engagedDetails = {'suppliers_data': true};
        this.drugDetails = data[0].details.reduce((acc, d) => {
          if (!engagedDetails[d.group_alias]) return acc;
          if (!acc[d.group_alias]) acc[d.group_alias] = {};
          acc[d.group_alias][d.alias] = {value: d[d.type + '_value'], type: d.type, id: d.id};
          return acc;
        }, {});
        if (!this.drugDetails?.suppliers_data) this.drugDetails.suppliers_data = {};
        if (!this.drugDetails?.suppliers_data?.order_rate) {
          this.drugDetails.suppliers_data.order_rate = {type: 'int', value: null}
        }
        if (!this.drugDetails?.suppliers_data?.oposit_order_rate) {
          this.drugDetails.suppliers_data.oposit_order_rate = {type: 'int', value: null}
        }

        if (!this.storeDrugData?.total) this.storeDrugData = {total: 0};
        if (this.freezeInvoices && this.freezeInvoices[this.drugId]) {
          this.storeDrugData.total += this.freezeInvoices[this.drugId].total_qty;
          const invoice = (this.invoices ?? []).find((i) => i.status === 0 && i.type === 1);
          this.freezeInvoices[this.drugId].current_cost_price = Math.round((invoice?.cost_price ?? 0) * 100) / 100 ?? 0;
          // this.freezeInvoices[this.drugId].current_cost_price = (this.invoices && this.invoices.length && Math.round(this.invoices[0].cost_price * 100) / 100) || 0;
          this.freezeInvoices[this.drugId].cost_diff = Math.round((this.freezeInvoices[this.drugId].cost_price - this.freezeInvoices[this.drugId].current_cost_price) * 10) / 10
        }
        this.drug = data[0];
        this.drugRequestQty = Math.floor(this.drug.request_qty);
      }
      this.drugDataLoading = false;
      setTimeout(() => {
        this.showOrderComponent = true;
      }, 300);
    },
  }
}

</script>
